import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { UnionOfficeService } from '../union-office.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Union, UserType, Gender, Taluk, District, State, RelationType } from '../../agent/agent-interface.service';
import { GlobalValidationService } from 'src/app/global-validation.service';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-union-office-register',
  templateUrl: './union-office-register.component.html',
  styleUrls: ['./union-office-register.component.scss']
})
export class UnionOfficeRegisterComponent implements OnInit {
  action: string = '';
  union_office_register_form: FormGroup;
  unions: Union[] = [];
  user_types: UserType[] = [];
  genders: Gender[] = [];
  taluks: Taluk[] = [];
  districts: District[] = [];
  states: State[] = [];
  offices: State[] = [];
  roles: State[] = [];

  constructor(private formBuilder: FormBuilder, private unionOfficeService: UnionOfficeService, private http: HttpService, private global: GlobalService) {
    this.getCvData();
    this.union_office_register_form = this.formBuilder.group({
      id: [null],
      union_id: [null, Validators.compose([Validators.required])],
      name: [null, Validators.compose([Validators.required])],
      street: [null],
      address: [null],
      taluk_id: [null, Validators.compose([Validators.required])],
      district_id: [null, Validators.compose([Validators.required])],
      state_id: [1, Validators.compose([Validators.required])],
      mobile: [null, Validators.compose([GlobalValidationService.checkMobileNumber, Validators.required])],
      alternate_mobile: [null, Validators.compose([GlobalValidationService.checkMobileNumber])],
      phone: [null],
    })

    if (this.unionOfficeService.get_union_office_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.unionOfficeService.get_union_office_data);
    }

    this.unionOfficeService.unionOfficeUpdate.subscribe((union_office) => {
      if (union_office === null) {
        this.action = 'register';
        this.union_office_register_form.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(union_office);
      }
    });

    this.unionOfficeService.unionOfficeUpdate.subscribe((union_office) => {
      this.setupUpdateForm(union_office);
    });
   }

   setupUpdateForm(element) {
     console.log(element)
    this.union_office_register_form.controls['id'].setValue(element['id']);
    this.union_office_register_form.controls['name'].setValue(element['name']);
    this.union_office_register_form.controls['union_id'].setValue(element['union_id']);
    this.union_office_register_form.controls['street'].setValue(element['street']);
    this.union_office_register_form.controls['address'].setValue(element['address']);
    this.union_office_register_form.controls['taluk_id'].setValue(element['taluk_id']);
    this.union_office_register_form.controls['district_id'].setValue(element['district_id']);
    this.union_office_register_form.controls['state_id'].setValue(element['state_id']);
    this.union_office_register_form.controls['mobile'].setValue(element['mobile']);
    this.union_office_register_form.controls['alternate_mobile'].setValue(element['alternate_mobile']);
    this.union_office_register_form.controls['phone'].setValue(element['phone']);
   }

   getCvData() {
    this.getDistricts();
    this.getTaluk();
    this.getState();
    this.getOffice();
    this.getUnion();
   }

   getDistricts() {
    this.http.getDistrict().subscribe((data: District[]) => {
      console.log(data);
      this.districts = data;
    }, (error) => {
      console.log(error);
    });
  }

  getUnion() {
    this.http.getUnions().subscribe((data: Union[]) => {
      console.log(data);
      this.unions = data;
    }, (error) => {
      console.log(error);
    });
  }

  getTaluk() {
    this.http.getTaluks().subscribe((data: Taluk[]) => {
      console.log(data);
      this.taluks = data;
    }, (error) => {
      console.log(error);
    });
  }

  getState() {
    this.http.getStates().subscribe((data: State[]) => {
      console.log(data);
      this.states = data;
    }, (error) => {
      console.log(error);
    });
  }

  getOffice() {
    this.http.getOffice().subscribe((data: State[]) => {
      console.log(data);
      this.offices = data;
    }, (error) => {
      console.log(error);
    });
  }

  registerUnionOffice() {
    const union_office_data = Object.assign({}, this.union_office_register_form.value);
    console.log(union_office_data)
    this.http.registerUnionOffice(union_office_data).subscribe((data) => {
      this.union_office_register_form.reset();
      this.global.showSnakeBar(data['message']);
      this.unionOfficeService.downloadUnionOffice.emit(true);
    });
  }


  ngOnInit() {
  }

}
